<template>
<div>
	<div class="d-flex justify-content-between align-items-center">
		<h2>Draw Breakdown<br>
			<small>Project #{{$store.project.job_num}}, {{$store.project.job_name}}</small>
		</h2>
		<div>
			<button v-if="acceptedBid" class="btn btn-light btn-sm" type="button" v-on:click="confirmImportBidModal.visible = true">
				Import Bid Items...
			</button>
		</div>
	</div>

	<table-list v-if="!invoiceModeLocal"
		record-name="Item"
		:fields="scheduleFields"
		:records="mutateTasks(tasks)"
		:has-delete="$store.project.schedule_of_values_finalized == 0"
		:has-edit="$store.project.schedule_of_values_finalized == 0"
		:rows-draggable="$store.project.schedule_of_values_finalized == 0"
		:has-drag-handle="$store.project.schedule_of_values_finalized == 0"
		:hide-record-count="true"
		delete-endpoint="JobTask/delete"
		v-on:modelChange="fetchProjectTasks(true)"
		v-on:edit="editScheduleItem"
		v-on:dragEnd="reorderRows">

		<div class="d-flex flex-row justify-content-between">
			<div v-if="$store.project.schedule_of_values_finalized == 0">
				<button class="btn btn-success" type="button" v-on:click="addNewScheduleItem(false)">
					<i class="fa fa-plus"></i>
					Add Item
				</button>

				<button class="btn btn-light ml-1" type="button" v-on:click="finalizeSchedule(true)">
					<i class="fa fa-lock"></i>
					Lock
				</button>
			</div>
			<div v-else>   

				<router-link class="btn btn-success ml-1" type="button" :to="'/project/'+$route.params.id+'/billing/new'">
					<i class="fa fa-file-invoice-dollar"></i>
					Draw Invoice
				</router-link>

				<button class="btn btn-light ml-1" type="button" v-on:click="finalizeSchedule(false)">
					<i class="fa fa-lock-open"></i>
					Unlock
				</button>
			</div>

			<div class="d-flex">
				<info-box label="Original Project Value" :value="'$ ' + originalProjectValue.toCurrency()" :stacked="true"></info-box>
				<info-box label="Total Completed to Date" :value="totalCompletedToDate()" :stacked="true"></info-box>
				<info-box label="Total Change Order Value" :value="'$ ' + totalChangeOrderValue.toCurrency()" :stacked="true"></info-box>
				<info-box label="Total Project Value" :value="'$ ' + totalProjectValue.toCurrency()" :stacked="true"></info-box>
			</div>
		</div>

		<div style="max-width: 350px;margin-top: 10px;">
			<field v-if="$store.project.schedule_of_values_finalized == 0"
					label="Holdback %"
				col-class="col-md-6"
				:params="{type:'number',step:0.1,min:0,max:100}"
				v-model="holdbackPercent"
				v-on:change="saveHoldback">
			</field>
			<p v-else><strong>Holdback: {{holdbackPercent}}%</strong></p>

			<field label="Progress Tracking:"
				col-class="col-md-6"
				:params="{type:'boolean',doubleLabels:['Unit','%']}"
				:readonly="$store.project.schedule_of_values_finalized == 1"
				v-model="$store.project.schedule_of_values_by_percent"
				v-on:change="toggleProgressType">
			</field>
		</div>

	</table-list>

	<h3>Change Orders</h3>

	<table-list v-if="!invoiceModeLocal"
		record-name="Item"
		:fields="changeFields"
		:records="mutateChangeOrders(changeOrders)"
		:has-edit="'/project/'+$store.project.slug+'/change-quotes/{?}'"
		id-field="slug"
		edit-button-text="View"
		edit-button-icon="fa-eye"
		:clickable-row="true"
		:rows-draggable="true"
		:has-drag-handle="true"
		:hide-record-count="true"
		v-on:dragEnd="reorderRows">

		<!--<button class="btn btn-success" type="button" v-on:click="addNewScheduleItem(true)">
			<i class="fa fa-plus"></i>
			Add Change Order
		</button>-->

	</table-list>

	<modal-dialog
		:modal-visible="scheduleItemModal.visible"
		:title="scheduleItemModal.title"
		confirm-button-text="Save"
		:working="scheduleItemModal.working"
		v-on:confirm="saveItem"
		v-on:closeModal="scheduleItemModal.visible = false">

		<field label="Item Number" 
			col-class="col-sm-4" 
			
			v-model="scheduleItemModal.record.item_number">
		</field>

		<field label="Description" 
			col-class="col-sm-4" 
			v-model="scheduleItemModal.record.description">
		</field>

		<field label="Unit Value" 
			col-class="col-sm-4" 
			:params="{type:'number',step:0.01}"
			v-model="scheduleItemModal.record.unit_value">
		</field>

		<field label="Qty" 
			col-class="col-sm-4" 
			:params="{type:'number',min:0,step:0.01}"
			v-model="scheduleItemModal.record.qty">
		</field>

	</modal-dialog>

	<modal-dialog
		:modal-visible="confirmImportBidModal.visible"
		title="Import Bid Items"
		confirm-button-text="Confirm"
		:working="confirmImportBidModal.working"
		v-on:confirm="importBidItems"
		v-on:closeModal="confirmImportBidModal.visible = false">

		Would you like to copy the accepted bid items into the Schedule of Values?

	</modal-dialog>
</div>
</template>
<script type="text/javascript">
import Field from "@/components/Field"
import TableList from "@/components/TableList"
import ModalDialog from "@/components/ModalDialog"
import InfoBox from "@/components/InfoBox"
import ContextMenu from "@/layout_fragments/ContextMenu"

import InvoiceMixins from "@/mixins/InvoiceMixins.js"
import ProjectBidMixins from "@/mixins/ProjectBidMixins.js"

export default {
	components: {
		TableList,
		Field,
		ModalDialog,
		InfoBox,
		ContextMenu
	},
	mixins: [InvoiceMixins,ProjectBidMixins],
	props: ["invoiceMode"],
	data() {
		return {
			tasks: [],
			changeOrders: [],
			invoices: [],
			holdbackPercent: this.$store.project.holdback_percentage * 100,
			confirmImportBidModal: {
				visible: false,
				working: false
			},
			scheduleItemModal: {
				visible: false,
				title: "Add New Item",
				record: {},
				new: false,
				working: false,
			},
			scheduleFields: [
				{label: "Item Number",key:"item_number"},
				{label: "Description",key:"description"},
				{label: "Qty",key:'qty',align:"right"},
				{label: "Unit Value $",key:"unit_value",align:"right"},
				{label: "Total Value $",key:'totalValue',align:"right"},
				{label: "Compl. Qty",key:'completedQty',align:"right"},
				{label: "Compl. %",key:'completedPercent',align:"center"},
				{label: "Compl. $",key:'completedDollars',align:"right"}
			],
			changeFields: [
				{label: "Item Number",key:"item_number"},
				{label: "Request #",key:'request_num'},
				{label: "Change Ref #",key:"change_order_ref"},
				{label: "Total Value $",key:'totalValue',align:"right"},
				{label: "Compl. Qty",key:'completedQty',align:"right"},
				{label: "Compl. %",key:'completedPercent',align:"center"},
				{label: "Compl. $",key:'completedDollars',align:"right"}
			],
			deleteContractModalVisible: false,
			invoiceModeLocal: false
		}
	},
	watch: {
		'$store.project'() {
			if ("id" in this.$store.project){
				this.fetchData()
				this.holdbackPercent = this.$store.project.holdback_percentage * 100
			}
		},
		invoiceMode() {
			this.invoiceModeLocal = this.invoiceMode

			if (this.invoiceModeLocal && this.invoices.length == 0)
				this.fetchInvoices(true)
		}
	},
	computed: {
		originalProjectValue() {
			console.log(this.tasks)
			return this.tasks.reduce((acc,task) => acc + parseFloat(task.totalValue.toFloat().round(2)),0)
		},
		totalChangeOrderValue() {
			return this.mutateChangeOrders(this.changeOrders).reduce((acc, co) => acc + parseFloat(co.totalValue.toFloat().round(2)),0)
		},
		totalProjectValue() {
			return this.originalProjectValue + this.totalChangeOrderValue
		},
		acceptedBid() {
			if (this.$store.project && "JobBid" in this.$store.project && this.$store.project.JobBid) 
				return this.$store.project.JobBid.find(bid => bid.status == 'Accepted')
			
			return false
		}
	},
	methods: {
		totalCompletedToDate() {
			let totalValue = this.tasks.reduce((acc,task) => acc + +task.qty * +task.unit_value,0)
			let totalCompleted = this.tasks.reduce((acc,task) => acc + +task.unit_value * +task.completedQtyRaw,0)

			if (totalCompleted == 0)
				return "0%"

			let totalCompletedPercent = totalCompleted / totalValue * 100

			return totalCompletedPercent.round(1)+"%"
		},
		editScheduleItem(record) {
			this.scheduleItemModal.visible = true
			this.scheduleItemModal.record = record
			this.scheduleItemModal.title = "Edit Item"
			this.scheduleItemModal.new = false
		},
		addNewScheduleItem(change) {
			this.scheduleItemModal.visible = true
			this.scheduleItemModal.record = {
				description: null,
				unit_value: null,
				item_number: null,
				is_change: change ? 1 : 0
			}
			this.scheduleItemModal.title = change ? "Add New Change Order" : "Add New Item"
			this.scheduleItemModal.new = true
		},
		toggleProgressType(percent) {
			let payload = {
				id: this.$store.project.id,
				schedule_of_values_by_percent: percent ? 1 : 0
			}

			this.postData("Job/save",payload)
		},
		saveItem() {

			let vm = this

			this.scheduleItemModal.record.unit_value = parseFloat(this.scheduleItemModal.record.unit_value).toFixed(2)

			let payload = this.scheduleItemModal.record

			payload.job_id = this.$store.project.id

			this.scheduleItemModal.working = true

			this.postData("JobTask/save",payload,true).then(response => {
				vm.scheduleItemModal.visible = false

				vm.alertSaved("Item saved")
				vm.scheduleItemModal.working = false

				vm.fetchProjectTasks(true)
			})
			
		},
		reorderRows(event) {
			let movedItem = this.tasks.splice(event.oldIndex,1)
			//insert into new place
			this.tasks.splice(event.newIndex,0,movedItem[0])

			let vm = this

			let payload = {
				records: this.tasks.map((task,index) => {
					return {
						id: task.id,
						sort_order: index
					}
				})
			}

			this.postData("JobTask/save-batch",payload)
		},
		saveHoldback() {
			let vm = this

			let payload = {
				id: this.$store.project.id,
				holdback_percentage: this.holdbackPercent / 100
			}

			this.postData("Job/save",payload,true).then(response => {
				if (response.success)
					vm.alertSaved("Holdback % change saved")
			})
		},
		finalizeSchedule(finalize) {
			let vm = this

			this.postData("Job/save",{id: this.$store.project.id, schedule_of_values_finalized: finalize ? 1 : 0},true).then(response => {

				if (response.success) {
					if (finalize)
						vm.$store.project.schedule_of_values_finalized = 1
					else
						vm.$store.project.schedule_of_values_finalized = 0
				}

			})
		},
		importBidItems() {
			this.confirmImportBidModal.working = true

			let vm = this

			let job_id = this.$store.project.id

			this.fetchAllComponents(this.acceptedBid.id).then(response => {

				//iterate through second-layer items
				let records = this.renderJobTaskPayloadFromBid(this.renderNestedBid())

				if (records.length > 0) {
					let payload = {
						records: JSON.stringify(records)
					}

					this.postData("JobTask/save-batch",payload,true).then(response => {
						this.confirmImportBidModal.working = false
						this.confirmImportBidModal.visible = false
						vm.alertSuccess(records.length + " items added to the Schedule of Values!")

						vm.fetchData()
					})
				}
				else
					vm.alertFail("There are no bid components!")
			})
		},
		fetchData() {
			let vm = this

			let promises = [
				this.fetchProjectTasks(false),
				this.fetchProjectChangeOrders(false)
			]

			if (!this.invoiceModeLocal)
				promises.push(this.fetchProjectInvoices(false,["JobInvoiceTask"]))

			vm.spinner(true)

			Promise.all(promises).then(response => {
				vm.spinner(false)
			})
		}
	},
	created() {
		if ("id" in this.$store.project)
			this.fetchData()

		this.invoiceModeLocal = this.invoiceMode
	}
}
</script>

<style type="text/css" scoped>
	.table thead th[rowspan=2] {
		vertical-align: middle;
	}

	.th-no-border {
		border-bottom: none;
	}

	.completed-details {
		width: 200px;
	}

	.completed-bar {
		height: 5px;
		color: blue;
	}
</style>